import { defaultHoursSchedule } from './placeHours';

export const BLOG_TEMPLATE_OPTIONS = [
  { code: 'template_1', name: 'Template 1 — Editorial / guía' },
  { code: 'template_2', name: 'Template 2 — Lugares' },
];

export const HEADING_LEVEL_OPTIONS = [
  { label: 'H2', value: 2 },
  { label: 'H3', value: 3 },
  { label: 'H4', value: 4 },
  { label: 'H5', value: 5 },
  { label: 'H6', value: 6 },
];

export const SECTION_CATALOG = {
  template_1: [
    { code: 'heading', label: 'Heading (H2–H6 + rich text)' },
    { code: 'paragraph', label: 'Paragraph (rich text)' },
    { code: 'rich_text', label: 'Rich text (HTML)' },
    { code: 'quote', label: 'Quote' },
    { code: 'image', label: 'Image' },
  ],
  template_2: [
    { code: 'heading', label: 'Heading (H2–H6 + rich text)' },
    { code: 'paragraph', label: 'Paragraph (rich text)' },
    { code: 'rich_text', label: 'Rich text (HTML)' },
    { code: 'quote', label: 'Quote' },
    { code: 'image', label: 'Image' },
    { code: 'place_block', label: 'Place block' },
  ],
};

export function clampHeadingLevel(level) {
  const n = Number(level);
  if (!Number.isFinite(n)) return 2;
  return Math.min(6, Math.max(2, Math.round(n)));
}

export function defaultSectionData(type) {
  switch (type) {
    case 'heading':
      return {
        level: 2,
        text: '',
        html: '',
        html_updated: '',
        anchor: '',
        show_in_toc: true,
      };
    case 'paragraph':
      return { html: '', html_updated: '', anchor: '', show_in_toc: false };
    case 'rich_text':
      return { html: '', anchor: '', show_in_toc: false };
    case 'quote':
      return { text: '', anchor: '', show_in_toc: false };
    case 'image':
      return {
        url: '',
        alt: '',
        caption: '',
        credit: '',
        pinned: false,
        anchor: '',
        show_in_toc: false,
      };
    case 'place_block':
      return {
        title: '',
        html: '',
        html_updated: '',
        chips: [],
        open_status: '',
        address: '',
        hours: '',
        hours_schedule: defaultHoursSchedule(),
        from_garita: '',
        specialty: '',
        before_you_go: '',
        anchor: '',
        show_in_toc: true,
        links: {
          maps: { url: '', alt: '' },
          website: { url: '', alt: '' },
          facebook: { url: '', alt: '' },
          instagram: { url: '', alt: '' },
          tiktok: { url: '', alt: '' },
        },
      };
    default:
      return {};
  }
}

export function createSection(type) {
  return {
    id: `${type}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    type,
    data: defaultSectionData(type),
  };
}

/** Normalize sections loaded from API for the editor (html_updated working copy). */
export function normalizeSectionsForEditor(sections = []) {
  return (sections || []).map((section) => {
    if (!section || typeof section !== 'object') return section;
    if (section.type === 'heading') {
      const html = section.data?.html || '';
      return {
        ...section,
        data: {
          ...defaultSectionData('heading'),
          ...(section.data || {}),
          level: clampHeadingLevel(section.data?.level),
          html,
          html_updated: html,
        },
      };
    }
    if (section.type === 'paragraph') {
      const html = section.data?.html || '';
      return {
        ...section,
        data: {
          ...defaultSectionData('paragraph'),
          ...(section.data || {}),
          html,
          html_updated: html,
        },
      };
    }
    if (section.type === 'place_block') {
      const html = section.data?.html || '';
      return {
        ...section,
        data: {
          ...defaultSectionData('place_block'),
          ...(section.data || {}),
          html,
          html_updated: html,
        },
      };
    }
    return section;
  });
}

/** Strip editor-only fields before persisting. */
export function serializeSectionsForSave(sections = []) {
  return (sections || []).map((section) => {
    if (!section || typeof section !== 'object') return section;
    const data = { ...(section.data || {}) };
    if (section.type === 'heading') {
      data.level = clampHeadingLevel(data.level);
      data.html = data.html_updated || data.html || '';
      delete data.html_updated;
    }
    if (section.type === 'paragraph') {
      data.html = data.html_updated || data.html || '';
      delete data.html_updated;
    }
    if (section.type === 'place_block') {
      data.html = data.html_updated || data.html || '';
      delete data.html_updated;
    }
    return { ...section, data };
  });
}
